import React, { useEffect, useMemo, useState } from 'react';
import { SelettoreArchivio, nellaVista, useVistaArchivio } from '../../../../components/Util/archivioProdotti';
import { useNavigate } from 'react-router-dom';
import { apriComeLaStruttura } from "../../../../components/Util/vistaStruttura";
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { nomiSport } from "../../../../components/Util/sportProdotto";
import DEFAULT_STRUTTURA from "../../../../../images/DEFAULT_STRUTTURA.png";

import { conMotivo } from "../../../../components/Util/erroreServer";
export const AdminFacilitiesTable = () => {
	const navigate = useNavigate();

	const [data_json, setDataJson] = useState(null);
	// In uso / Archivio (TASK #7): in archivio solo gli impianti messi su «Archiviato»
	const [vista, setVista] = useVistaArchivio();
	const filteredData = useMemo(() => data_json && data_json.filter((row) => nellaVista(vista, row)), [data_json, vista]);
	const [reloadKey, setReloadKey] = useState(0);

	const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);
	const [confirmText, setConfirmText] = useState('');

	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

	const [loadingShowed, setLoadingShowed] = useState(false);

    const data_column = [
		{
			Header: 'Struttura',
			accessor: 'clubName',
			Cell: ({ row }) => {
				return (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							src={row.original.imageUrlClub ? row.original.imageUrlClub : DEFAULT_STRUTTURA}
							alt={row.original.clubName}
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50%',
								marginRight: '10px'
							}}
						/>
						<div>
							{row.original.clubName}
						</div>
					</div>
				)
			}
		},
		{
			Header: 'Nome',
			Footer: 'Nome',
			accessor: 'name',
		},
		{
			Header: 'Descrizione',
			Footer: 'Descrizione',
			accessor: 'description',
		},
		{
			Header: 'Sport',
			Footer: 'Sport',
			accessor: 'sportType',
		},
	];

	// L'impianto si apre con la pagina della struttura, come la vede lei, in sola lettura (vistaStruttura.js)
	function openDetail(row) {
		apriComeLaStruttura(navigate, { clubId: row.clubId, nome: row.clubName, percorso: `/struttura/booking/facilitiesedit/${row.id}` });
	}

	const deleteDetail = (row) => {
		setOnContinue(() => () => continueDelete(row));
		setConfirmShowed(true);
		setConfirmText("L'impianto sarà eliminato.");
    };

    const continueDelete = (row) => {
	
		setConfirmShowed(false);

		const deleteData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString) {
					const tokenDetails = JSON.parse(tokenDetailsString);
					const token = tokenDetails.idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const deleteResult = await apiClient.deleteVenue(token, row.id);
					setLoadingShowed(false);

					console.log(deleteResult)

					if(!deleteResult) {
						setModalTitle("Errore durante l'operazione");
						setModalText(conMotivo("Si è verificato un errore durante l'eliminazione"));
						setModalShowed(true);
					} else {
						setReloadKey(k => k + 1);
					}
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		deleteData();
	};

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [venues] = await Promise.all([
                        apiClient.getVenues(token)
                    ]);
					setLoadingShowed(false);

					if(venues) {
						let data = [];
						venues.forEach(element => {

							let imageClub = null;
                            if(element.clubPicture) {
								imageClub = element.clubPicture.uri;
							}

							let row = {
								"id": element.id,
								"name": element.name,
								"description": element.description,
								"sportType": nomiSport(element),
								"imageUrlClub": imageClub,
								"clubName": element.clubName || '-',
								"clubId": element.clubId,
								"archivio": !!element.archived,
							};
							data.push(row);
							
						});
						setDataJson(data);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, [reloadKey]);

    return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>
			
			<Modal className="fade" show={confirmShowed} centered>
				<Modal.Header>
					<Modal.Title>Eliminare l'impianto?</Modal.Title>
					<Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64" dangerouslySetInnerHTML={{ __html: confirmText }}></Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
						Annulla
					</Button>
					<Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
						Elimina
					</Button>
				</Modal.Footer>
			</Modal>

			<TabellaLista
				pageList={true}
				cardTitle={'Impianti'}
				hasSearch={true}
				searchPlaceholder={'Cerca per struttura, nome, descrizione o sport'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<SelettoreArchivio value={vista} onChange={setVista} />
					</div>
				}
				data_column={data_column}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				data_json={filteredData}
				hasAddMore={false}
				linkAddMore={'/superadmin/booking/facilities/new'}
				labelAddMore={'Nuovo impianto'}
				sort_by={'name'}
                sort_type={'asc'}
				modalCallBack={() => setModalCentered(true)}
			/>
		</>
	)
};

export default AdminFacilitiesTable;